import { osName } from "react-device-detect";

export enum Shortcuts {
  KeyE = "KeyE",
  ArrowUp = "ArrowUp",
  ArrowDown = "ArrowDown",
  ArrowLeft = "ArrowLeft",
  ArrowRight = "ArrowRight",
  Space = "Space",
}

const isMacOS = osName === "Mac OS";

const secondKey = isMacOS ? "shiftKey" : "altKey";

const keyView = {
  [Shortcuts.KeyE]: "E",
  [Shortcuts.ArrowUp]: "↑",
  [Shortcuts.ArrowDown]: "↓",
  [Shortcuts.ArrowLeft]: "←",
  [Shortcuts.ArrowRight]: "→",
  [Shortcuts.Space]: "Space",
  shiftKey: "Shift",
  altKey: "Alt",
  metaKey: isMacOS ? "⌘ Cmd" : "⊞ Win",
};

const action = {
  [Shortcuts.KeyE]: "Toggle Edit",
  [Shortcuts.ArrowUp]: "Increase speed by 10 WPM",
  [Shortcuts.ArrowDown]: "Decrease speed by 10 WPM",
  [Shortcuts.ArrowLeft]: "Seek backwards 30 secs",
  [Shortcuts.ArrowRight]: "Seek forward 30 secs",
  [Shortcuts.Space]: "Toggle play/pause",
};

export const isCombination = ({ metaKey, [secondKey]: second }: KeyboardEvent) => metaKey && second;

export const shortcutList = Object.keys(Shortcuts).map((a) => ({
  id: a,
  combination: [keyView["metaKey"], keyView[secondKey], keyView[a as Shortcuts]],
  action: `${action[a as Shortcuts]}.`,
}));
